"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalAudioMuteButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const rxjs_1 = require("../../../../hooks/rxjs");
const room_session_1 = require("../../../../context/room_session");
const toolbar_button_1 = require("./toolbar_button");
const normalize_audio_level_1 = require("../../../../util/normalize_audio_level");
const ui_react_1 = require("@streem/ui-react");
const LocalAudioMuteButton = () => {
    const theme = (0, ui_react_1.useTheme)();
    const roomSession = (0, room_session_1.useRoomSession)();
    const [label, setLabel] = (0, react_1.useState)('');
    const [localAudioEnabled] = (0, rxjs_1.useObservable)(roomSession.media.localAudio.enabled);
    const [localAudioStarted] = (0, rxjs_1.useObservable)(roomSession.media.localAudio.started);
    const [localAudioLevel] = (0, rxjs_1.useObservable)(roomSession.media.localAudio.audioLevel);
    (0, react_1.useEffect)(() => {
        let msg = '';
        if (!localAudioStarted) {
            msg = 'No Microphone Found';
        }
        else if (localAudioStarted && localAudioEnabled) {
            msg = 'Mute';
        }
        else if (localAudioStarted && !localAudioEnabled) {
            msg = 'Unmute';
        }
        setLabel(msg);
    }, [localAudioEnabled, localAudioStarted]);
    return ((0, jsx_runtime_1.jsx)(toolbar_button_1.ToolbarButton, { "data-testid": label, fillLevel: localAudioEnabled ? (0, normalize_audio_level_1.normalizeAudioLevel)(localAudioLevel) : undefined, fill: localAudioEnabled ? theme.colors.azure : theme.colors.red50, hoverFill: localAudioEnabled ? theme.colors.azureTransparent : theme.colors.red50Transparent, disableButton: !localAudioStarted, label: label, iconName: localAudioEnabled ? 'MuteIcon' : 'MutedIcon', onClick: () => roomSession.media.localAudio.setEnabled(!localAudioEnabled) }));
};
exports.LocalAudioMuteButton = LocalAudioMuteButton;
//# sourceMappingURL=local_audio_mute_button.js.map